export type PremiumPlan = 'monthly' | 'yearly' | 'lifetime';

export const PREMIUM_PLAN_PRICING: Record<PremiumPlan, number> = {
  monthly: 4.99,
  yearly: 47.88,
  lifetime: 89.99,
};

export const YEARLY_MONTHLY_EQUIVALENT = PREMIUM_PLAN_PRICING.yearly / 12;

export const GIFT_CARD_BULK_DISCOUNT_THRESHOLD = 10;
export const GIFT_CARD_BULK_DISCOUNT_RATE = 0.1;

export const getPremiumPlanPrice = (plan: PremiumPlan): number => {
  return PREMIUM_PLAN_PRICING[plan];
};
